import { Link } from 'react-router-dom';
import { NavigateRoutesEnum } from '@routing/routesEnum';



const About = (): JSX.Element => {

	return (
		<div className='footer-menu about-section'>

			<Link to={NavigateRoutesEnum.about} className='disable-selection'>
				Proč Vetlímce
			</Link>

			<Link to={NavigateRoutesEnum.partners} className='disable-selection'>
				Pro partnery
			</Link>

			{/*<Link to={NavigateRoutesEnum.basePath} className='disable-selection'>
				Kariéra
			</Link>*/}

			<Link to={NavigateRoutesEnum.contact} className='disable-selection'>
				Kontakt
			</Link>

			{/*<Link to={NavigateRoutesEnum.basePath} className='disable-selection'>
				Zákaznická podpora
			</Link>*/}
			
		</div>
	);
}

export default About;